import { render } from "./SimpleLayout.vue?vue&type=template&id=dd7e1790&ts=true"
import script from "./SimpleLayout.vue?vue&type=script&lang=ts"
export * from "./SimpleLayout.vue?vue&type=script&lang=ts"

import exportComponent from "d:\\jenkins-nodes\\Atlanta\\workspace\\Atlanta-FE-Git-189PRE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__